import { Col, Row, Modal, Button, Table } from "antd";
import type { ColumnsType } from "antd/es/table";
import { BarcodeOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
type propsType = {
  openSerial: boolean;
  setOpenSerial: React.Dispatch<React.SetStateAction<boolean>>;
};
interface DataType {
  key: string;
  Serialnumberlist: string;
}
export const SerialNumber = ({ openSerial, setOpenSerial }: propsType) => {
  const [t] = useTranslation("common");
  const columns: ColumnsType<DataType> = [
    {
      title: `${t("Serial-number-list")}`,
      dataIndex: "Serialnumberlist",
      key: "Serialnumberlist",
      align: "center" as "center",
    },
  ];
  const data: DataType[] = [
    {
      key: "1",
      Serialnumberlist: "235564675889967080",
    },
    {
      key: "2",
      Serialnumberlist: "235564675889967080",
    },
  ];
  return (
    <Modal
      centered
      closable={false}
      maskClosable={false}
      width={500}
      onCancel={() => setOpenSerial(false)}
      open={openSerial}
      okButtonProps={{ style: { display: "none" } }}
      cancelButtonProps={{
        style: {
          color: "#1677FF",
          border: "1px solid #1677FF",
          marginInlineEnd: "auto",
        },
      }}
      cancelText={t("cancel")}
    >
      <Row gutter={[0, 10]}>
        <Col>
          <Button type="text" icon={<BarcodeOutlined />}></Button>
          <span style={{ marginRight: "20px" }}> {t("serial-numbers")} </span>
        </Col>

        <Col span={24}>
          <Table
            columns={columns}
            dataSource={data}
            pagination={false}
            rowClassName={(record, index) =>
              index % 2 === 0
                ? "table-row-light table-row"
                : "table-row-dark table-row"
            }
          />
        </Col>
      </Row>
    </Modal>
  );
};
